import "./Dpu_Mca_Highlight.css";

const Dpu_Mca_Highlight = () => {
  const highlights = [
    {
      img: "/assets/images/dpu_mca/industry-alignedcurriculum.svg",
      title: "Industry-Aligned Curriculum",
      desc:
        "Stay ahead with modules designed in consultation with tech industry leaders.",
    },
    {
      img: "/assets/images/dpu_mca/job-focusedspecialisations.svg",
      title: "Job-Focused Specialisations",
      desc:
        "Choose your career path with options such as Data Science, AI/ML, Cloud Computing, and Cybersecurity.",
    },
    {
      img: "/assets/images/dpu_mca/lms.svg",
      title: "AI-Driven Learning Management System (LMS)",
      desc:
        "LMS integrates tools and cloud-based services to accelerate e-learning.",
    },
    {
      img: "/assets/images/dpu_mca/practicallearning.svg",
      title: "Practical Learning",
      desc:
        "Engage in hands-on coding, capstone projects, simulations, and virtual labs that simulate real-world tech challenges.",
    },
    {
      img: "/assets/images/dpu_mca/expert-led-live.svg",
      title: "Expert-Led Live Sessions & Webinars",
      desc: "Learn from top faculty and industry practitioners.",
    },
    {
      img: "/assets/images/dpu_mca/globallearningenvironment.svg",
      title: "Global Learning Environment",
      desc:
        "Connect with peers and faculty from across India and around the world.",
    },
    {
      img: "/assets/images/dpu_mca/dedicatedcareersupport.svg",
      title: "Dedicated Career Support",
      desc:
        "Resume reviews, mock interviews, industry networking, and placement assistance.",
    },
    {
      img: "/assets/images/dpu_mca/scholarshipsaffordability.svg",
      title: "Scholarships & Affordability",
      desc: "Merit-based scholarships for course payment.",
    },
  ];

  return (
    <section className="Dpu_Mca_Highlight">
      <div className="container">
        <div>
          <div className="col-lg-12">
            <h2 className="text-center mt-0 mb-2">
              Online MCA Program Highlights
            </h2>
          </div>
        </div>

        <div className="data_holder">
          <div className="row">
            {highlights.map((item, index) => (
              <div className="col-lg-3 col-md-6 mb-4" key={index}>
                <div className="row">
                  <div className="col-lg-3 col-md-3 col-12">
                    <img
                      src={item.img}
                      className="img-fluid me-2"
                      width="50"
                      alt={item.title}
                    />
                  </div>
                  <div className="col-lg-9 col-md-9 col-12">
                    <h5 className="text-white mb-0">
                      <strong className="head_text">{item.title}:</strong>
                    </h5>
                    <small className="text-white descn_text">{item.desc}</small>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dpu_Mca_Highlight;
